import useLogbooks from '@/hooks/useLogbooks';
import useCompanies from '@/hooks/useCompanies';
import useUser from '@/hooks/useUser';
import LogbookReview from '../../components/LogbookReview/LogbookReview';
import {useWindowScroll} from '@uidotdev/usehooks';
import {useEffect, useState} from 'react';
import './AdminLogbooks.scss';

function AdminLogbooks() {
  const {user} = useUser();
  const {companies} = useCompanies();
  const [companyId, setCompanyId] = useState('');
  const {data, isLoading, size, setSize, isValidating, mutate} = useLogbooks(companyId || undefined);
  const [{y: yPos}] = useWindowScroll();
  const [fetchNext, setFetchNext] = useState(false);

  useEffect(() => {
    if (!companyId && user?.companyId) {
      setCompanyId(user.companyId);
    }
  }, [companyId, user]);

  const handleCompanyChange = (e) => {
    setCompanyId(Number(e.target.value));
    setSize(1);
  };

  const isLoadingMore = isLoading || (size > 0 && data && typeof data[size - 1] === 'undefined');
  const isRefreshing = isValidating && data && data.length === size;

  useEffect(() => {
    if (
      yPos + window.innerHeight >= document.body.offsetHeight - 2000 &&
      yPos + window.innerHeight > 1500
    ) {
      setFetchNext(true);
    }
  }, [yPos]);

  useEffect(() => {
    if (
      fetchNext &&
      size * 2 <= data?.[0].totalCount &&
      !isLoadingMore &&
      data?.length &&
      !isRefreshing
    ) {
      setSize(size + 1);
      setFetchNext(false);
    }
  }, [fetchNext, size, data, isLoadingMore, isRefreshing, setSize]);

  const mutateLogbook = (index) => {
    mutate(data, {
      revalidate: (pageData, [, , page]) => page === index,
    });
  };

  return (
    <main className="container mb-5">
      <div className="dashboard admin-logbooks">
        <div className="row">
          <div className="col-12">
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
              <div className="name mb-0">Cuadros de Avance</div>
              {companies?.length > 1 && (
                <div className="company-filter d-flex align-items-center">
                  <select
                    value={companyId}
                    onChange={handleCompanyChange}
                    className="form-control form-select company-filter-select"
                  >
                    {companies.map(({id, name}) => (
                      <option key={id} value={id}>
                        {name}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </div>
            {data?.map((logbooksData, logbooksDataIndex) =>
              logbooksData.logbooks?.map?.((logbook, logbookIndex) => (
                <LogbookReview
                  key={`logbooksData.${logbooksDataIndex}.${logbookIndex}`}
                  logbook={logbook}
                  mutate={() => mutateLogbook(logbooksDataIndex)}
                />
              ))
            )}
          </div>
        </div>
      </div>
    </main>
  );
}

export default AdminLogbooks;
